import { lazyLoad } from 'utils/loadable';

export const QuizFormPage = lazyLoad(
  () => import('./index'),
  module => module.QuizFormPage,
);
